import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import InputIcon from '../../shared/common/InputIcon';
import NoResultsFound from '../../shared/common/NoResultsFound';
import ActionButton from '../blog/ActionButton';
import AnnouncementsCard from './AnnouncementsCard';
import { getAllPopUpSlidesByCompany } from '../../redux/api/announcements';

const TabPopUp = props => {
    const { user } = props;

    // STATE
    const [search, setSearch] = useState('');
    const [popups, setPopUps] = useState([]);
    const [popupsFiltered, setPopUpsFiltered] = useState([])

    const [tabValue, setTabValue] = useState(0);

    // EFFECTS

    useEffect(() => {
        if (popups.length === 0) {
            getAllPopUp(user.id);
        }
    }, []);

    useEffect(() => {
        if (search.length !== 0) {
            console.log('searchpopups')
            searchpopups(popups, search)
        } else {
            getAllPopUp(user.id);
        }
    }, [search]);

    // FUNCTIONS

    const getAllPopUp = async (id) => {
        let req = await getAllPopUpSlidesByCompany(id);
        console.log('req', req.data);
        if (!!req) {
            setPopUps(req.data);
        }
        // if(req.error){
        // 	alert("Ocurrió un error")
        // }else{
        // 	setPopUps(req)
        // }
    };

    function handleSearch(e) {
        setSearch(e.target.value);
    }


    const searchpopups = (array, search) => {
		let newArray = []
		array.forEach(item => {
			if( item.attributes?.title?.toLowerCase().includes(search.toLowerCase()) 
			){ 
				newArray.push(item)
			}
		}
	);
    setPopUpsFiltered(newArray.length === 0 ? [] : newArray)
	}

    return (
        <>
            <HeaderWrapper>
                <InputIcon value={search} onChange={handleSearch} />
                <ActionButton title="Añadir PopUp" action="/new-pop-up" icon={<AddRoundedIcon />} bgc="var(--primary-one)" textColor="#ffff" />
            </HeaderWrapper>
            {
                search.length === 0
                ?   ( popups.length === 0 
                    ?   ( <NoResultsFound message="No existe contenido del blog, añade un artículo." /> ) 
                    :   (
                            <GridValues>
                                { popups.map(value => value.id !== undefined &&
                                    <AnnouncementsCard 
                                    value={value.attributes} 
                                    key={value.id} 
                                    artId={value.id} 
                                    type='pop-up'/>)
                                }
                            </GridValues>
                        )
                    )
                :   ( popupsFiltered.length === 0
                    ?   ( <NoResultsFound message="No se encuentran resultados para tu búsqueda" /> ) 
                    :   (
                            <GridValues>
                                { popupsFiltered.map(value => value.id !== undefined &&
                                    <AnnouncementsCard 
                                    value={value.attributes} 
                                    key={value.id} 
                                    artId={value.id}
                                    type='pop-up'
                                    // aDeletedArticle={aDeletedArticle}
                                    />)
                                }
                            </GridValues>
                        )
                    )
            }
        </>
    );
};

export default TabPopUp;

const GridValues = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    height: auto;
    grid-gap: 1.5rem;
    justify-content: center;
    align-items: flex-start;
    justify-items: center;
    align-content: stretch;
    @media screen and (max-width: 425px) {
        display: flex;
        flex-direction: column;
        column-gap: 1rem;
    }
`;

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: calc(100% - 4rem);
    padding: 1rem  2rem;
    gap: 1rem;
    align-items: center;
    column-gap: 1.5rem;
`;
